import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import AppLayoutWrapFull from "components/AppLayoutWrapFull";
import Container from "components/Container/Container";
import PageHeader from "components/PageHeader/PageHeader";
import PageHeaderActions from "components/PageHeader/components/PageHeaderActions/PageHeaderActions";
import FullDataTable from "components/DataTable/FullDataTable";
import TableDefIncidents from "table-defs/TableDefIncidents";

import {
    loadIncidentsAction,
    deleteIncidentAction,
    loadSitesAction,
    approveIncidentAction,
    completeIncidentAction,
    notifyIncidentAction,
    investigationIncidentAction,
    loadIncidentTypesAction
} from "store/actions/Actions";

import useFilterRows from "helpers/customHooks/useFilterRows";

import { setSelectedRows, toggleDropdowns } from "helpers/utils";

const Incidents = props => {
    const [state, setState] = useState({
        selectedRows: null,
        selected_sites: []
    });

    const {
        loadSitesAction,
        completeIncidentAction,
        loadIncidentsAction,
        approveIncidentAction,
        loadIncidentTypesAction,
        SitesReducer,
        IncidentsReducer,
        IncidentTypesReducer,
        investigationIncidentAction,
        deleteIncidentAction,
        notifyIncidentAction,
        UserOrgSiteReducer,
    } = props;

    useEffect(() => {
        if (!SitesReducer.sites) {
            loadSitesAction();
        }
    }, [SitesReducer.sites, loadSitesAction]);

    useEffect(() => {
        if (!IncidentTypesReducer.incidentTypes) {
            loadIncidentTypesAction();
        }
    }, [IncidentTypesReducer.incidentTypes, loadIncidentTypesAction]);

    useEffect(() => {
        if (!IncidentsReducer.incidents && SitesReducer.sites && IncidentTypesReducer.incidentTypes) {
            loadIncidentsAction();
        }
    }, [IncidentsReducer.incidents, loadIncidentsAction, IncidentTypesReducer.incidentTypes, SitesReducer.sites]);

    // ##############################################

    const noFilters = {
        text: "",
        type: "",
        "last-action": "",
        status: "",
        role: "",
        site: "",
        start: "",
        end: "",
        selected_sites: [],
        dateField: "occurred"
    };

    const [filters, setFilters] = useState(noFilters);

    const setFilter = filterName => e => {
        setFilters({
            ...filters,
            [filterName]:
                e.target.type === "checkbox"
                    ? e.target.checked
                    : e.target.value || ((e.target && e.target.attributes && e.target.attributes.value && e.target.attributes.value.value) || '')
        });
    };

    const setDateFilter = filterName => value => {
        setFilters({
            ...filters,
            [filterName]: value
        });
    };

    const filteredRows = useFilterRows(filters, IncidentsReducer.incidents);

    // ##############################################

    const onChangeRowSelect = ({ selectedRows }) => {
        if (selectedRows !== state.selectedRows) {
            setState(s => ({
                ...s,
                selectedRows
            }));
        }
    };

    // const is_admin = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_admin) || false;
    const is_officer = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_officer) || false;
    const is_super = (UserOrgSiteReducer.selected && UserOrgSiteReducer.selected.is_super) || false;

    const chooseActionDropdownRef = React.createRef();
    const statusDropdownRef = React.createRef();
    const siteDropdownRef = React.createRef();

    const openAddNewIncident = () => props.history.push("/maintain/incidents/add-new-incident");

    const [selectedIncidentIds, setSelectedIncidentIds] = useState([]);

    return (
        <AppLayoutWrapFull onClick={toggleDropdowns([chooseActionDropdownRef, statusDropdownRef, siteDropdownRef])}>
            <PageHeader showStats={true}>
                <PageHeaderActions
                    primaryButtonText="ADD INCIDENT"
                    primaryButtonHandler={openAddNewIncident}
                    searchHandler={e =>
                        setFilters({ ...filters, text: e.target.value || "" })
                    }
                    searchValue={filters.text}
                    chooseActionDropdownRef={chooseActionDropdownRef}
                    chooseAction={
                        (is_officer || is_super) ? [
                        {
                            actionName: "Under Investigation Selected",
                            actionHandler: () => {
                                if (selectedIncidentIds.length > 0) {
                                    investigationIncidentAction(selectedIncidentIds);
                                }
                            }
                        },
                        {
                            actionName: "Verify Selected",
                            actionHandler: () => {
                                if (selectedIncidentIds.length > 0) {
                                    approveIncidentAction(selectedIncidentIds);
                                }
                            }
                        },
                        {
                            actionName: "Complete Selected",
                            actionHandler: () => {
                                if (selectedIncidentIds.length > 0) {
                                    completeIncidentAction(selectedIncidentIds);
                                }
                            }
                        },
                        {
                            actionName: "Notify Selected",
                            actionHandler: () => {
                                if (selectedIncidentIds.length > 0) {
                                    notifyIncidentAction(selectedIncidentIds);
                                }
                            }
                        },
                        {
                            actionName: "Delete Selected",
                            actionHandler: () => {
                                    deleteIncidentAction(selectedIncidentIds);
                            }
                        }
                    ]
                    :
                    [
    
                        {
                            actionName: "Under Investigation Selected",
                            actionHandler: () => {
                                if (selectedIncidentIds.length > 0) {
                                    investigationIncidentAction(selectedIncidentIds);
                                }
                            }
                        },
                        {
                            actionName: "Verify Selected",
                            actionHandler: () => {
                                if (selectedIncidentIds.length > 0) {
                                    approveIncidentAction(selectedIncidentIds);
                                }
                            }
                        },
                        {
                            actionName: "Notify Selected",
                            actionHandler: () => {
                                if (selectedIncidentIds.length > 0) {
                                    notifyIncidentAction(selectedIncidentIds);
                                }
                            }
                        },
                    ]
                    }
                    site={{
                        onClick: (e) => {
                            if (e.target.type === 'checkbox') {
                                let selected_sites = filters.selected_sites.slice();
                                if (e.target.checked) {
                                    selected_sites.push(e.target.value);
                                } else {
                                    selected_sites = selected_sites.filter(site => site !== e.target.value);
                                }
                                setFilters({
                                    ...filters,
                                    site: selected_sites.length > 0 ? `Sites (${selected_sites.length})` : 'Site',
                                    // site: "Site",
                                    selected_sites: selected_sites
                                });
                            }
                        },
                        sites: SitesReducer.sites ? SitesReducer.sites.map(site => {
                            return {
                                id: site.id,
                                siteName: site.name,
                                value: filters.selected_sites.includes(site.id) ? true : false
                            }
                        }) : [],
                    }}
                    siteDropdownRef={siteDropdownRef}
                    status={{
                        onChange: setFilter("status"),
                        options: ["All", "Not Verified", "Under Investigation", "Verified", "Completed"],
                    }}
                    statusDropdownRef={statusDropdownRef}
                    dateRange={{
                        onChangeStart: setDateFilter("start"),
                        onChangeEnd: setDateFilter("end")
                    }}
                    filters={filters}
                    resetFilters={() => {
                        setFilters(noFilters);
                    }}
                />
            </PageHeader>
            <Container wide fluid>
                {IncidentsReducer.incidents &&
                <FullDataTable
                    rowsData={filteredRows}
                    definitions={TableDefIncidents}
                    onChangeRowSelect={({ selectedRows }) => onChangeRowSelect({ selectedRows })}
                    customTableProps={
                        (is_officer || is_super) ? {
                            selectedRows: state.selectedRows,
                            viewIncident: id => {
                                props.history.push(`/maintain/incidents/edit?id=${id}`);
                            },
                            invetiagation: (id) => {
                                investigationIncidentAction([{ id }]);
                            },
                            approve: (id) => {
                                approveIncidentAction([{ id }]);
                            },
                            complete: (id) => {
                                completeIncidentAction([{ id }]);
                            },
                            notify: (id) => {
                                notifyIncidentAction([{ id }]);
                            },
                            delete: (id) => {
                                deleteIncidentAction([{ id }]);
                            }
                        } : {
                            selectedRows: state.selectedRows,
                            viewIncident: id => {
                                props.history.push(`/maintain/incidents/edit?id=${id}`);
                            },
                            invetiagation: (id) => {
                                investigationIncidentAction([{ id }]);
                            },
                            approve: (id) => {
                                approveIncidentAction([{ id }]);
                            },
                            notify: (id) => {
                                notifyIncidentAction([{ id }]);
                            },
                        }
                    }
                    onRowClick={function(e) {
                        if (
                            e.currentTarget.classList.contains("col-actions") ||
                            e.currentTarget.classList.contains(
                                "col-row-selector"
                            )
                        ) {
                            return;
                        }
                        props.history.push(`/maintain/incidents/edit?id=${this.props.rowData.id}`);
                    }}
                    setSelectedRows={setSelectedRows(["id"], setSelectedIncidentIds)}
                    filters={filters || {}}
                />
                }
            </Container>
        </AppLayoutWrapFull>
    );
};

const mapStateToProps = (state) => ({
    IncidentTypesReducer: state.IncidentTypesReducer,
    IncidentsReducer: state.IncidentsReducer,
    SitesReducer: state.SitesReducer,
    UserOrgSiteReducer: state.UserOrgSiteReducer,
});

const mapDispatchToProps = {
    loadSitesAction,
    loadIncidentTypesAction,
    loadIncidentsAction,
    approveIncidentAction,
    investigationIncidentAction,
    completeIncidentAction,
    notifyIncidentAction,
    deleteIncidentAction
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Incidents);
